module.exports = __webpack_public_path__ + "static/media/pricing5.cfb1bf3d.jpg";